import React, { useMemo } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'

import Table from "UI/Table"
import Filters from "Features/Filters"

const CoverageFilters = ({ filters, changeFilters, filterOptions = {} }) => (
  <Filters {...{ filters, onChange: changeFilters }}>
    <Filters.Select {...{ filterName: 'customers', options: filterOptions.customers }} />
    <Filters.Select {...{ filterName: 'locations', options: filterOptions.locations }} />
    <Filters.Select {...{ filterName: 'powerState', options: filterOptions.powerState, isMulti: false }} />
    <Filters.Select {...{ filterName: 'functions', options: filterOptions.functions }} />
    <Filters.Select {...{ filterName: 'licenseReportTypes', options: filterOptions.licenseReportTypes }} />
  </Filters>
)

const CoverageBar = ({ assetsInDatto, fullCount, automated_spla_reporting }) => {

  return (
    <ProgressBar label={`In Datto: ${assetsInDatto} / ${fullCount}`}>
      <ProgressBar
        title={`In Datto: ${assetsInDatto} / ${fullCount}`}
        variant='success'
        now={(assetsInDatto / fullCount) * 100}
        key={1}
      />
      <ProgressBar
        variant={automated_spla_reporting ? 'danger' : 'secondary'}
        now={((fullCount - assetsInDatto) / fullCount) * 100}
        key={2}
      />
    </ProgressBar>
  )
}

const CoverageTable = ({ assets }) => {
  const columns = useMemo(() => ([
    { Header: 'Name', accessor: 'short_name' },
    { Header: 'License Report Type', accessor: 'license_report_type' },
    { Header: 'VM Count', accessor: (customer) => customer.assets.length, id: 'vm_count', type: 'number', width: 100 },
    {
      Header: 'In Datto', accessor: row => (row.assetsInDatto / row.assets.length) * 100, id: 'coverage_percentage',
      Cell: ({ row: { _original: { assetsInDatto, assets, automated_spla_reporting } } }) => <CoverageBar {...{ assetsInDatto: assetsInDatto, fullCount: assets.length, automated_spla_reporting }} />
    }
  ]), [])
  const subColumns = useMemo(() => ([
    { Header: 'Name', accessor: 'name' },
    { Header: 'In Datto', accessor: 'inDatto', type: 'boolean' },
    { Header: 'OS', accessor: 'operating_system' },
    { Header: 'Power', accessor: 'power_state', type: 'powerState' }
  ]), [])

  return (
    <Table
      filterable
      columns={columns}
      data={assets}
      SubComponent={(row) => <Table filterable columns={subColumns} data={row.original.assets} />}
    />
  )
}

export { CoverageFilters, CoverageTable }
